export const NEWS_DESCRIPTION_LENGTH = 150;

export const DEV_URL = 'https://dev.tenis.io';
export const PROD_URL = 'https://tenis.io';

export const FACEBOOK_URL = 'https://www.facebook.com/tenisioapp';
export const TWITTER_URL = 'https://twitter.com/tenisioapp';
export const INSTAGRAM_URL = 'https://www.instagram.com/tenisioapp/';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.tenisturnuvasi';
export const APP_STORE_URL = 'https://apps.apple.com/tt/app/tenis-io/id1582320874';
